<template>
  <div style="height: 100%;">
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from '../../echarts/bar.vue'
export default {
  data() {
    return {
      cdata: {
        category: [
        "康保镇",
          "张纪镇",
          "土城子镇",
          "邓油坊镇",
          "李家地镇",
          "照阳河镇",
          "屯垦镇",
          "闫油坊乡",
          "丹清河乡",
          "哈咇嘎乡",
          "二号卜乡",
          "芦家营乡",
          "忠义乡",
          "处长地乡",
          "满德堂乡",
          "康保牧场",
          "屯垦林场",
        ],
        lineData: [
        72.64, 89.71 ,87.41 ,74.91 ,87.42 ,24.99 ,55.11 ,74.41 ,75.07 ,83.39 ,59.20 ,81.50 ,90.32 ,83.51 ,58.97 ,33.16 ,74.27 
        ],
        title: "",
        yAxisUnit:"%",
        rateData: []
      }
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.setData();
  },
  methods: {
    // 根据自己的业务情况修改
    setData() {

    },
  }
};
</script>

<style lang="scss" scoped></style>